import { render, staticRenderFns } from "./PdfContent.vue?vue&type=template&id=281ab7a2&scoped=true&"
import script from "./PdfContent.vue?vue&type=script&lang=js&"
export * from "./PdfContent.vue?vue&type=script&lang=js&"
import style0 from "./PdfContent.vue?vue&type=style&index=0&id=281ab7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281ab7a2",
  null
  
)

export default component.exports